export * from './LogoWhatsappIcon';
export * from './LogoWhatsappIcon16Light';
export * from './LogoWhatsappIcon16Regular';
export * from './LogoWhatsappIcon16Solid';
export * from './LogoWhatsappIcon20Light';
export * from './LogoWhatsappIcon20Regular';
export * from './LogoWhatsappIcon20Solid';
export * from './LogoWhatsappIcon24Regular';
export * from './LogoWhatsappIcon24Solid';
export * from './LogoWhatsappIcon32Regular';
export * from './LogoWhatsappIcon64Regular';
